import PropTypes from 'prop-types'

import { TESTING_COVER_IMAGE_URL } from '@/constants/testingHelpers'
import { routeFor } from '@/utils/router'

import ItemDetails from './ItemDetails'

const Item = ({ asset, price, variant }) => {
  const { productImageUrl, slug } = asset
  const IMAGE_WIDTH = 90
  const isTestCoverImage = productImageUrl.indexOf(TESTING_COVER_IMAGE_URL)

  const coverImageURL = isTestCoverImage !== -1
    ? productImageUrl
    : `${productImageUrl}/width/${IMAGE_WIDTH}?style=preview`

  return (
    <div className='d-md-flex flex-row'>
      <a
        aria-hidden='true'
        href={routeFor('asset', { id: slug })}
        tabIndex='-1'
      >
        <img
          alt=''
          className='cover-image'
          src={coverImageURL}
        />
      </a>
      <ItemDetails
        {...{
          asset,
          price,
          variant
        }}
      />
    </div>
  )
}

export default Item

Item.propTypes = {
  asset: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  variant: PropTypes.object.isRequired
}
